enum WorkflowSteps {
  Setup,
  Recording,
  Preview,
  Error
}

export default WorkflowSteps;
